import React from 'react';
import { feedbackConstants } from '../../../constants/common/feedbackConstants';

interface IAllUserRoles {
    ASSISTERENROLLMENTENTITY: string;
    ASSISTER: string;
    AGENCY_MANAGER: string;
    BROKER: string
};
interface Iuser {
    activeModuleName?: string
};
interface IEnvironment {
    impersonation: boolean;
    user: Iuser;
    showFeedBack: string;
    stateCode: string
};

function Feedback(props: { ALL_USER_ROLES: IAllUserRoles; environment: IEnvironment; openSurveyMonkey: Function }) {
    const { ALL_USER_ROLES, environment, openSurveyMonkey } = props;
    const { ASSISTERENROLLMENTENTITY, ASSISTER, AGENCY_MANAGER, BROKER } = ALL_USER_ROLES;
    const activeUserList: string[] = [ASSISTERENROLLMENTENTITY, ASSISTER, AGENCY_MANAGER, BROKER];
    let {
        impersonation = false,
        user,
        showFeedBack,
        stateCode
    } = environment;
    user=user || {}
    const {
        activeModuleName = '',
    } = user;

    const isShowFeedbackIcon = showFeedBack && !impersonation && activeUserList.includes(activeModuleName.toUpperCase());
    if (!isShowFeedbackIcon) {
        return null;
    }

    return (<div className='feedback-container'>
        <button className="usa-button gi-button gi-button__primary btn-feedback" id="feedback-open" onClick={() => openSurveyMonkey(stateCode)}>
            <i>
                <img
                    className="img-feedback"
                    src="/hix/resources/images/icons/feedback.png"
                    alt="Smiley face"
                    width="40"
                    height="30"
                />
            </i>
            <span className='text-feedback'>&nbsp;&nbsp;<strong>{feedbackConstants.FEEDBACK}</strong></span>
        </button>
    </div>);
}

export default Feedback